export default {
  "common-try-slogin": "Connect every person and app on the planet",
  "common-button-立即试用": "Try now",
  "common-consult": "Let's talk",
  "common-consult-descript":
    "For more information, please contact our sales and technical support team.",
  "common-customer": "Learn about Authing to help you grow fast",
  "common-more": "Learn more",
  "common-story": "Learn more",
  "input-placeholder": "Your phone number",
  "try-on": "Get Started",
  "check-fun": "Learn Features",
  "common-company": "Beijing Steamory Technology Co.",
  "timeline-title": "Change Log",
  "timeline-slogan": "Every effort counts for better function and experience",
  "timeline-publish": "Latest",
  "down-solution": "Download Solution",
  "how-use": "Learn more",
  check: "See More",
  nav: {
    "nav-docs": "https://docs.authing.cn/en/",
    "nav-home": "Home",
    "nav-ROI": "ROI Calculator",

    "nav-demo": "Demo",
    "nav-product": "Products",
    "nav-solution": "Solutions",
    "nav-resource": "Resources",
    "nav-cloud-native": "Cloud Native",
    "nav-case": "Cases",
    "nav-timeline": "Change Log",
    "nav-solution-medical": "Healthcare",
    "nav-solution-government": "Public Sector",
    "nav-solution-education": "Education",
    "nav-solution-consume": "Retail",
    "nav-solution-finance": "Finacial Services",
    "nav-solution-cars": "Automotive Services",
    "nav-solution-energy": "Energy",
    "nav-solution-game": "Game",
    "nav-solution-manufacture": "Manufacturing",
    "nav-solution-enterprise": "SaaS Services",
    "nav-solution-software": "Technology",
    "nav-solution-publisher": "Publishing",
    "nav-solution-wechat": "Wechat ecology",
    "nav-solution-idaas": "IDaaS replace IAM",
    "nav-solution-okta": "Move from Okta",
    "nav-solution-auth0": "Move from Auth0",
    "nav-solution-ad": "AD Identity Solution",
    "nav-solution-cognito": "Move from AWS Cognito",
    "nav-solution-keycloak": "Keycloak VS Authing",
    "nav-solution-private-cloud": "Privately Deployed Identity Cloud",
    "nav-solution-mfa": "Adaptive MFA",
    "nav-solution-build-idaas": "Build your own IDaaS",
    "nav-solution-identity": "Synchronization and update of user information",
    "nav-solution-zero-trust": "Building zero trust network for organizations",
    "nav-solution-digital-identity": "Building digital identity for citizens",
    "nav-developer": "Developer",
    "nav-developer-center": "Developer Center",
    "nav-developer-center-descript": "Find out about Authing development",
    "nav-developer-community": "Developer Forum",
    "nav-developer-community-descript": "Communicate with Authing engineers",
    "nav-developer-document": "Docs",
    "nav-developer-document-descript": "Quickly implement auth into your apps",
    "nav-developer-blog": "Blog",
    "nav-price": "Pricing",
    "nav-abuoutus": "About",
    "nav-company-intro": "About Us",
    "nav-customer": "Customer Stories",
    "nav-customer-success": "Customer Success Service",
    "nav-console": "Console",
    "nav-personal": "Personal",
    "nav-login": "Login",
    "nav-mobile-login": "Login",
    "nav-logout": "Logout",
    "nav-type-customer": "Customer Stories",
    "nav-marketplace": "Partner Network",
    "nav-customer-hep": "Higher Education Press",
    "nav-customer-cnpn": "PetroChina",
    "nav-customer-nreal": "Nreal",
    "nav-customer-southeast-university": "Southeast University",
    "nav-customer-xian-gong": "Xiangong Intelligent",
    "nav-customer-cocacola": "Coca Cola",
    "nav-customer-futu": "Futu Niuniu",
    "nav-customer-yuanqi": "Yuanqi Forest",
    "nav-customer-volkswagen": "Volkswagen",
    "nav-customer-jcdecaux": "JCDecaux",
    "nav-case-description":
      "Startups, Unicorns and fortune 500 companies trust Authing’s software and APIs to sign in, authorize, and manage your employees & users.",
    "nav-developer-blog-descript":
      "Check out the latest from Authing developers",
    "nav-type-developer-social": "Developer community",
    "nav-type-developer-resource": "Developer resources",
    "nav-developer-api": "Open API portal",
    "nav-developer-api-descript": "Help you get an Authing Ability",

    "nav-developer-doclink": "Common Document",
    "nav-resource-whitepaper": "White Book",
    "nav-resource-demo": "Demo Center",
    "nav-resource-whitepaper-descript":
      "Feel the convenience of integrated Authing",
    "nav-resource-demo-descript":
      "Feel the efficient interactivity of the Authing console",
    "nav-type-application": "Advantages of Authing",
    "nav-type-company": "Company",
    "nav-type-about": "About Us",
    "nav-type-news": "Express ",
    "nav-type-APN": "Authing Partner Network",
    "nav-type-APN-img":
      "//files.authing.co/authing-website/nav-about-img-apn-en.png",
    "nav-about-financing": "Investors",
    "nav-about-news": "Big News",
    "nav-type-product": "Product",
    "nav-type-service": "Security and Service",
    "nav-product-extra-title": "Product advantages",
    "nav-type-industry": "Industry Solutions",
    "nav-type-scense": "Scenario Solutions",
    "nav-type-staff": "Workforce Identity",
    "nav-type-user": "Customer Identity",
    "nav-type-extend": "Extended functions",
    "nav-extend-database": "Connect to custom database",
    "nav-extend-pipeline": "Pipeline",
    "nav-extend-operate": "IDaaS operation platform",
    "nav-extend-maintenance": "IDaaS maintenance platform",
    "nav-extend-radius": "Radius",
    "nav-solution-extra-title": "WeChat ecological solution",
    "nav-solution-extra-subtitle":
      "As an excellent provider of identity management solutions, Authing will bring significant competitive advantages to enterprises in B2B, B2C, B2E or IoT scenarios: reducing development costs, improving security, and boosting production efficiency.",
    "nav-type-developer": "Related Resources Introduction",
    "nav-type-developer-social": "Developer community",
    "nav-type-developer-resource": "Developer resources",
    "nav-developer-api": "Open API portal",
    "nav-developer-api-descript": "Help you get an Authing Ability",
    "nav-developer-extra-oidc": "Use OIDC",
    "nav-developer-extra-mfa": "Mobile security MFA",
    "nav-developer-extra-pipeline": "Custom Authenticate",
    "nav-developer-extra-pipeline-subtitle":
      "Flexible configuration of authentication",
    "nav-developer-extra-start": "Get Started",
    "nav-developer-extra-start-subtitle":
      "Make your apps available to millions of users",
    "nav-developer-extra-pipeline-img-default":
      "//files.authing.co/authing-website/nav-developer-pipeline-new-en-v2.png",
    "nav-developer-extra-pipeline-img":
      "//files.authing.co/authing-website/nav-developer-pipeline-default-en-v2.png",
    "nav-developer-extra-start-img-default":
      "//files.authing.co/authing-website/nav-developer-getstart-default-en-v2.png",
    "nav-developer-extra-start-img":
      "//files.authing.co/authing-website/nav-developer-getstart-new-en-v2.png",
    "nav-about-extra-title": "Learn about Authing",
    "news-blog1": "Authing Share｜Password: the cornerstone of security",
    "nav-tag-joinus": "Join Us",
    "learn-more": "Learn More",
    "nav-overview": "Overview",
    "news-blog2":
      "Following Facebook, LinkedIn exploded another 500 million data breaches, all key user information leaked out",
    "news-blog3":
      "How Theragun uses Authing to provide a unified login experience for millions of users",
    "nav-developer-api-user": "Authentication API",
    "nav-developer-api-user-des": "User Sign In / Logout",
    "nav-developer-api-manage": "Management API",
    "nav-developer-api-manage-des": "Users / Organizations management",
  },
  footer: {
    "footer-product": "Features",
    "footer-product-advance": "Product Advantages",
    "footer-platform": "Open Platform",
    "footer-solution": "Solutions",
    "footer-platform-api": "Open API",
    "footer-platform-resource": "Develop Resources",
    "footer-support-doc": "Developer Doc",
    "footer-platform-problem": "FAQ",
    "footer-platform-example": "Integration Cases",
    "footer-support": "Technical Support",
    "footer-doc": "Developer Doc",
    "footer-friendly-link": "Links",
    "footer-support-community": "Developer Forum",
    "footer-support-Github": "GitHub",
    "footer-support-blog": "Tech Blog",
    "footer-company": "Company",
    "footer-network": "Partner System",
    "footer-company-joinus": "Careers",
    "footer-company-phone": "400 888 2106",
    "footer-company-email": "sales@authing.com",
    "company-address-name": "Beijing address (Headquarter)",
    "branch-address-name": "Chengdu address (Branch)",
    "shanghai-address-name": "Shanghai address (Branch)",
    "wuhan-address-name": "Wuhan address (Branch)",
    "shanghai-company-address":
      "No. 300, Guan Min Road, Yangpu District, Shanghai",
    "wuhan-company-address":
      "Horizon, 7th Floor, Poly International Center, New Lake New Technology Development Zone, Wuhan",
    "shenzhen-company-address":
      "Room A10, 14th Floor, Building 3, Nanshan Keyuan Road, Shenzhen",
    "mobile-total-company-address":
      "16 / F, Block B, NORTH STAR CENTURY CENTER, Beijing(total)",
    "mobile-branch-company-address":
      "room 406, 4th floor, zone B, building 1, No. 200, Tianfu Fifth Street, Chengdu(branch)",
    "mobile-shanghai-company-address":
      "No. 300, Guan Min Road, Yangpu District, Shanghai(branch)",
    "mobile-shenzhen-company-address":
      "Room A10, 14th Floor, Building 3, Nanshan Keyuan Road, Shenzhen(branch)",
    "mobile-wuhan-company-address":
      "Horizon, 7th Floor, Poly International Center, New Lake New Technology Development Zone, Wuhan(branch)",
    "beijing-company-address":
      "16 / F, Block B, NORTH STAR CENTURY CENTER, Beijing",
    "chengdu-company-address":
      "Room 406, 4th floor, zone B, building 1, No. 200, Tianfu Fifth Street, Chengdu",
    "footer-privacy-policy": "Privacy Policy",
    "footer-service-agreement": "Service Agreement",
    "footer-language": "Language",
    "footer-adress": "Beijing ICP No.19051205-1",
    "footer-beian": "Beijing No.11010802035968",
    "footer-copyright": "© Beijing Steamory Technology Co.",
    "footer-sitemap": "Site Map",
    "footer-okta": "OKTA",
    "footer-solution-wechat": "Wechat ecology",
    "footer-solution-cognito": "Move from AWS Cognito",
    "footer-juzi": "Juzi.bot",
    "footer-mingdao": "Mingdao",
    "footer-hengshi": "HENGSHI",
    "footer-kalacloud": "KalaCloud",
    "footer-mingque": "MingQue",
    "footer-apiseven-link": "https://www.apiseven.com/en",
    "footer-gitlab": "Gitlab",
    "footer-gitlab-link": "https://about.gitlab.cn/en/",
    "footer-pay-news": "Pay information",
    "footer-merico": "Merico",
    "footer-fbmms": "Fbmms",
    "footer-dragontest": "DragonTesting",
    "city-title": "5 cities across the country",
    beijing: "Beijing（Headquarter）",
    shanghai: "Shanghai",
    shenzhen: "Shenzhen",
    chengdu: "Chengdu",
    wuhan: "Wuhan",
    extendAdress:
      "Building 4, No. 8 Beichen West Road, Chaoyang District, Beijing",
  },
  common: {
    "product-identity": "Identity Automation",
    "product-sso": "Single Sign-On",
    "product-mfa": "Adaptive MFA",
    "product-comp": "Universal Login",
    "product-verify": "Mobile Number Verification",
    "product-security": "Security & Compliance",
    "product-database": "Custom Database Connection",
    "product-authorization": "Authorization",
    "product-api": "API Access Verification",
    "product-user-management": "User Management",
    "product-user-directory": "User Directory",
    "product-life-cycle": "Lifecycle Management",
    "product-gateway": "Access Gateway",
    "product-gateway-integration": "Access Gateway",
    "product-authority": "Authorization Management",
    "product-tenant": "Multi-Tenant",
  },
  button: {
    "try-now": "Try now",
    "trial-request": "Trial request",
    "try-now-roi": "Calculate ROI",
    "buy-now": "Buy now",
    "see-more": "Learn more",
    "learn-more": "Learn more",
    "develop-consult": "development consultation",
    "develop-community": "Develop Doc",
    "contact-us": "Contact Us",
    "quick-start": "Quick start",
    consult: "Let's talk",
    "wait-consult": "Not now",
    linkDoc: "View docs",
    "check-now": "Check now",
    detail: "Learn More",
    community: "Join Now",
    "check-case": "User case",
    expect: "Coming soon",
    review: "Annual Review",
  },

  form: {
    name: "Name",
    phone: "Phone",
    company: "Company",
    other: "Remarks",
    submit: "Submit now",
    cancel: "Cancel",
    // "contact-form-title":
    //   "An expert will contact you within 15 minutes after completion",
    "contact-form-title": "Access to enterprise level solution",
    "contact-subtitle":
      "Authing has exported hands-on solutions to more than 28 industries. We are happy to share our experience with your organization and provide free demos.",
    "success-tip": "Submitted successfully! ",
    "success-down-tip": "Submitted successfully! ",
    "success-wait-tip": "Experts are on their way...",
    "success-try-tip": "Please call 400 888 2106 for immediate service.",
    "name-placeholder": "What do we hope we call you？",

    "phone-placeholder": "Our consultant will call you as soon as possible",

    "company-placeholder": "Please fill in your company information",
    position: "Position",
    "position-placeholder": "Please fill in your position information",
    "contact-name": "Name",
    "contact-way": "Phone",
    "contact-title": "Access to enterprise level solution",

    "contact-tip": "You can also contact our sales staff via WeChat or phone.",
    "apply-title": "Submit your application",
    "apply-name": "Name",
    "apply-email": "Email",
    "apply-type": "Type",
    "apply-position": "Delivery Position",
    "apply-method": "Resume delivery method",
    "mail-address": "Email address",
    "mail-address-info": "Please send your resume",
    "mail-title": "Mail Title: Name + Post Title",
    "mail-content": "Delivery content: Mail content + Attached resume",
    otherTip: "Would you like to contact a customer service representative?",
    otherTip1: "Please call",
    otherTip2: "contact us",
  },
  formPage: {
    subtitle:
      "Fast-growing companies that are giving their identity to Authing",
    title: "",
    name: "Name",
    company: "Conpany Name",
    industry: "Industy",
    position: "Position",
    phone: "Phone",
    scene: "Application Scenarios(Choice)",
    finance: "Finance",
    energy: "Energy",
    car: "Car",
    manufacture: "Manufacturing",
    food: "Food",
    retail: "New consumption",
    server: "Corporate Services",
    meta: "Meta",
    game: "Game",
    consult: "Consultation service",
    estate: "Estate",
    media: "Media",
    educate: "Education",
    medical: "Medical",
    other: "Other",
    remark: "Notes",
    b2b:
      "I want to provide a better authentication experience for my B-terminal customers.",
    b2c:
      "I want to provide a better identity authentication experience for my C-terminal users.",
    b2e: "I want to manage the company's employee",
  },
  // startedFree: "Started Free",
  startedFree: "calculate now",
  formNotice: "Calculating ROI for your identity management projects!",
  // formNotice:
  //   "Create the identity system to improve enterprise management and development efficiency.",
  notice:
    "Authing is participating in HW operation for 10 working days. Please go to www.authing.co to learn more. Consulting Tel: 19816542466 or 17602502507",
  // notice:
  //   "The new version of Authing has been released on 2020-09-17, and its performance has improved by leaps and bounds. Consulting Tel: 176-0250-2507",
  linkDoc: "View Document",
  about: {
    title: "About Authing",
    description1: `Authing is the first developer-centric identity cloud in China. It integrates all the mainstream identity authentication protocols and provides complete and secure user authentication and access management services for enterprises and developers. `,
    description2: `Authing was recognized as "2020 national high tech enterprise" by the Ministry of science and technology, and was selected as "domestic innovation enterprise in the field of identity management and access control" by the China Academy of information and communications, and was included in the 2019 white paper on the network security industry. In August 2021, Authing was selected as one of Forbes Asia's Top 100 Companies to Watch list. In September 2021, Authing was successfully selected as a member unit of the "Zhuoxin Big Data Project" of the China Academy of Information and Communications Technology. Authing is now having 200+ employees & has created an excellent development model, efficient office procedure, and safety management system for enterprises across the world, such as PetroChina, State Grid, China Merchants Bank, Toyota, JCDecaux group, etc.`,
    qrcodePublic: "「Authing Identity Cloud」Public",
    qrcodeBusiness: "Business Cooperation",
  },
  logo: {
    中国石油: "CNPC",
    国家电网: "STATE GRID",
    丰田: "TOYOTA",
    招商银行: "CHINA MERCHANTS BANK",
    高等教育出版社: "HIGHER EDUCATION PRESS",
    东南大学: "SOUTHEAST UNIVERSITY",
    华西医院: "WEST CHINA HOSPITAL SICHUAN UNIVERSITY",
    德高集团: "JCDecaux",
    云测: "Tertin",
    盼达用车: "PAND-AUTO",
    THERAGUN: "THERAGUN",
    宾利: "Bentley",
    stackchat: "Stackchat",
    chatopera: "Chatopera",
    腾讯云: "Tencent Cloud",
    亚马逊: "AWS",
    乐智机器人: "LEZHI ROBOT-STEAM EDUCATION",
    文因互联: "MEMECT",
    金蝶: "Kingdee",
    freeCodeCamp: "freeCodeCamp",
    阿里云: "Aliyun",
    句子互动: "Juzi",
    华为云: "Hua Weiyun",
    金证优智: "Jin Zheng Youzhi",
    一清创新: "Yiqing innovation",
  },

  pageLink: {
    title: "Learn more",
    sso: {
      title: "Single Sign-On",
      description:
        "Single Sign-On is one of the solutions for integrating enterprise systems, ...",
    },
    mfa: {
      title: "Adaptive MFA",
      description: "Adaptive MFA is a simple and effective...",
    },
    comp: {
      title: "Universal Login",
      description:
        "The guard helps developers shield themselves from many of the implementation...",
    },
    verify: {
      title: "Mobile Number Verification",
      description:
        "Relying on the official real name user information of wechat, users can...",
    },
    database: {
      title: "Custom Database Connection",
      description:
        "When you want to ensure data security or smooth migration of users, please use Authing...",
    },
    iam: {
      title: "IDaaS replace IAM",
      description:
        "With the rapid development of digital transformation and cloud computing, the dimensions...",
    },
    okta: {
      title: "Move from Okta",
      description:
        "By comparing with Okta from six dimensions of identity platform, workflow, directory,...",
    },
    wechat: {
      title: "Wechat ecology",
      description:
        "Authing quickly realize the identity authentication and user management of any web,...",
    },
    keycloak: {
      title: "Keycloak VS Authing",
      description:
        "Keycloak is an open-source software product designed to provide a single sign-on a...",
    },
    buildIdaas: {
      title: "Build your own IDaaS",
      description:
        "As businesses accelerate their digital transformation, 「identity and access management...",
    },
    finance: {
      title: "Financial industry solution",
      description:
        "We establish a unified authentication system, enhance security and risk control, and help...",
    },
    manufacture: {
      title: "Advanced manufacturing",
      description:
        "We build high-productivity, high-security, and high-performance identity management platforms...",
    },
    ad: {
      title: "Enhanced Microsoft AD Solution",
      description:
        "In the past, enterprises relied on AD for validating resource access, but this is no longer...",
    },
    price: {
      title: "Pricing",
      description:
        "You only need to pay for active users. Authing has helped thousands of enterprises and developers...",
    },
    tech: {
      title: "Technology Solution",
      description:
        "Unified authentication, delivering technology products with a great user experience.",
    },
  },
  chatrobot: {
    scan: "Scan for",
    privateService: " services",
    support1: "Add company WeChat",
    support2: "",
    online: "Online",
    wecom: "WeCom",
    token: "Token",
    ceoEmail: "CEO-Mail",
    phone: "Phone",
    onlineTip1: "Contact us online",
    onlineTip2: "To create a perfect identity system",
    wecomTip: "Add Wecom to receive industry information",
    tokenTip:
      "Download the Authing token and experience fast login authentication!",
    ceoEmailTip: "Direct feedback to the CEO",
    phoneTip: "Contact specialists by phone",
    freeUse: "Free Trial",
    alreadyCopy: "Copied",
  },
  "quotation-consultation": "Quotation",
  "chat-online": "Online",
  "chat-phone": "Phone",
  "tool-package": {
    title: "Media Kit",
    subtitle: "Provide resources for various format for use",
    toolTip: {
      title: "Want to download LOGO ?",
      downMediaKit: "Download LOGO",
      viewMediaKit: "View Media Kit",
    },
  },
  news: {
    title: "Pay information",
    "pay-button": "Pay ¥ 9.9",
    news1: {
      title: `Authing announced the launch of Yunyun's "multi-tenant" identity solution`,
      text: `Authing is a developer-centered, iDaas product based on cloud original architecture, is an independent, neutral, scalable, secure cloud identity management infrastructure, supporting all businesses and developers, convenient access to all kinds of scenes. Demand. 
      Recently, Authing announced that the identity authentication and authorization solution under the "multi-tenant" scenario is to help SaaS industry customers quickly online complicated "multi-tenant" management capabilities, while helping their partners to provide better identity. Manage full journey experience.`,
    },
    news2: {
      title: "What is we selling when talking about SaaS?",
      text: `On October 24, the identity cloud platform Authing announced the completion of $ 23 million A round financing. This round of financing is a leader of the Tiger Global Fund, Dinghui VGC (Innovation and Growth Fund), Voice Network Agora, Old Shareholders GGV Jiyuan Capital and the Legend of the Chuango, Yue to the capital as an exclusive financial adviser. On the afternoon of November 19, the A-round financing reporter reception was successfully held, and many well-known media participated in the industry. Authing Founder Xie Yang published "When talking about selling SaaS, what are we selling?" The subject speech, the following is the wonderful review of this speech.`,
    },
    news3: {
      title: "Spring Security Integrated CAS Project Code Certification (3)",
      text: `In the previous article ("CAS In the Authang Console Configuration Authentication (2)"), we talked how to configure the CAS required in the Authang platform configuration project integration, and how to get configured during the post-development process. At the same time, you also make everyone pre-study and familiar with some of the knowledge points needed during the construction and encoding process. Next this section, let's take a smooth completion of the project construction and encoding process.`,
    },
    news4: {
      title:
        "Manufacturing Identity Authentication Unified Management Solution",
      text: `China's manufacturing transformation, is imminent, and relating to survival. In the face of trouble, you should seek change. Over the years, China's manufacturing industry has been in a fast-growing expressway, benefiting from the continuous development of the "incremental" market. However, in today's economic growth, today, how to use digital and information technology to transform manufacturing, let the manufacturing breakthrough "inventory" difficulties brought about by "stock" market, is becoming the current deep tillage in manufacturing The direction of business exploration.`,
    },
  },
};
